import { formatValue, formatColumnValue, registerNeedToCache, getFromCacheOrFetch, getUrlOfLink2One } from "./formatter";
import { getFieldAndBindPath } from "./schema-helper";
import { tr } from "./locales";
import { openDialog } from "./dialogs";
import Mustache from "mustache";
import { bind, getSavePatch, save } from "../libs/binding";
import { waiter } from "./utils";

window.Z_GRID = {} ;
const highlightFilter = window.Z_GRID.highlightFilter = function(filter, value){
    if(!filter || !value){ return value ;}
    const valueLower = value.toLowerCase() ;
    const filterLower = filter.toLowerCase() ;

    const indexStart = valueLower.indexOf(filterLower) ;
    if(indexStart !== -1){
        return value.substring(0, indexStart)+
            "<b>"+value.substring(indexStart, indexStart+filter.length)+"</b>"
            +value.substring(indexStart+filter.length) ;
    }
    return value ;
} ;


export function createColDefFromSchema(modelPath, appName) {
    const { field } = getFieldAndBindPath(modelPath);
    return createColDef(field, appName) ;
}

export function createColDef(schemaColumn, appName) {
    let schema = window.APP.schema ;
    if(appName && window.APPS[appName]){
        schema = window.APPS[appName].schema ;
    }

    const columnDef = {} ;

    let zIsPopup = false;
    let zIsDialog = false;
    // if(schemaColumn.references) {
    //     zIsPopup = true;
    // }else 
    if (["date", "datetime", "textarea", "reference", "radio", "icon", "code-html", "compose-html", "array-selection", "user"].indexOf(schemaColumn.type) !== -1){
        zIsPopup = true;
    }else if(schemaColumn.type === "one2many"){
        zIsDialog = true;
    }

    const tableName = schemaColumn.tableName;
    columnDef.cellEditorParams =  {
        zModel: schemaColumn.tableName+"."+schemaColumn.name,
        zIsPopup: zIsPopup,
        zIsDialog: zIsDialog,
        zType: schemaColumn.type,
        zSchemaColumn: schemaColumn
    } ;
    if(appName){
        columnDef.cellEditorParams.zApp = appName;
    }
    columnDef.field = schemaColumn.name;
    if (!columnDef.headerName && schemaColumn) {
        const keyTr = "models."+tableName+"."+schemaColumn.name ;
        const trLabel = tr(keyTr) ;
        if(trLabel !== keyTr){
            //in translation
            columnDef.headerName = trLabel;
        }else{
            columnDef.headerName = schemaColumn.label || schemaColumn.name ;
        }
    }

    if (!columnDef.type) {
        if(schemaColumn.type === "integer" || schemaColumn.type === "double" ){
          columnDef.type = "numericColumn";
        }
    }
    if (schemaColumn.type === "html") {
        columnDef.cellRenderer = function (params) {
            return highlightFilter(params.column.gridApi.filterManager.quickFilter, params.value);
        };
    } else if (columnDef.submodel) {
        columnDef.cellRenderer = columnDef.valueFormatter = columnDef.getQuickFilterText = function (params) {
            if (!params.value) { return ""; }
            if (!Array.isArray(params.value)) { return ""; }
            return params.value.map((value) => {
                return columnDef.submodel.columns.filter((col) => {
                    return col.name.indexOf("_") !== 0;
                }).map((col) => {
                    return formatValue(value[col.name], col.type);
                }).join(", ");
            }).join(" / ");
        };
    } else if (schemaColumn.type === "one2many") {
        columnDef.valueFormatter = function(params){ 
            if(params.value){
                return params.value.filter(v=>!v.__isNewLine).length+" "+tr("grid.records") ;
            }
            return ""; 
        } ;
        columnDef.getQuickFilterText = function(){ 
            return ""; 
        } ;
        columnDef.cellRenderer = function (params) {
            if(!params.data || !params.data._id){ return "" ; }
            let eDiv = null ;
            if(!params.colDef.editable){
                eDiv = document.createElement('button');
            }else{
                eDiv = document.createElement('div');
            }
            eDiv.className = "text-right w-100 btn btn-outline-info" ;
            eDiv.style.marginTop = "-5px" ;
            if(params.value){
                eDiv.innerHTML = params.value.filter(v=>!v.__isNewLine).length+" "+tr("grid.records") ;
            }else{
                if(params.data._id){
                    eDiv.innerHTML = '<i class="fas fa-circle-notch fa-pulse"></i>' ;
                    let promiseCounts = null;
                    if(params.api.__cache2many && params.api.__cache2many[schemaColumn.name]){
                        promiseCounts = Promise.resolve(params.api.__cache2many[schemaColumn.name]) ;
                    }else{
                        const search = { groupby: schemaColumn.one2many.column } ;
                        promiseCounts = window.getRestApi(params.colDef.cellEditorParams.zApp).search(schemaColumn.one2many.model, search) ;
                    }
                    promiseCounts.then((results)=>{
                        //params.data[params.colDef.field] = results ;
                        if(!params.api.__cache2many){
                            params.api.__cache2many = {};
                        }
                        params.api.__cache2many[schemaColumn.name] = results;
                        let len = "0" ;
                        let result = results.find(r=>r[schemaColumn.one2many.column] === params.data._id) ;
                        if(result){
                            len = result.count;
                        }
                        eDiv.innerHTML = len+" "+tr("grid.records") ;
                    }).catch((err)=>{
                        console.error("Error while fetch one2many", err) ;
                        eDiv.innerHTML = "error" ;
                    }) ;
                }
            }
            if(!params.colDef.editable){
                eDiv.addEventListener("click", ()=>{
                    openDialog((el, $modal)=>{
                        const zList = document.createElement("z-list") ;
                        if(params.colDef.cellEditorParams.zApp){
                            zList.setAttribute("z-app", params.colDef.cellEditorParams.zApp) ;
                        }
                        zList.setAttribute("z-open-url", "") ;
                        zList.setAttribute("z-model", schemaColumn.one2many.model) ;
                        zList.setAttribute("z-filter", schemaColumn.one2many.column+"="+params.data._id) ;
                        zList.setAttribute("readonly", true) ;
                        zList.setAttribute("z-buttons", '[]') ;
                        el.appendChild(zList) ;
                        bind(el) ;
                        zList.querySelectorAll("button[type='button'].dropdown-toggle").forEach(btn => {
                            btn.addEventListener("click", ()=>{
                                if(btn.parentElement.className.includes("show")) {
                                    btn.parentElement.classList.remove("show");
                                    btn.nextElementSibling.classList.remove("show");
                                } else {
                                    btn.parentElement.classList.add("show");
                                    btn.nextElementSibling.classList.add("show");
                                }
                            });
                        });
                        // translateElement(zList);
                    }, {size: "fullscreen"}) ;
                }) ;
            }
            return eDiv;
        };
    } else if (schemaColumn.type === "email") {
        columnDef.cellRenderer = function (params) {
            return highlightFilter(params.column.gridApi.filterManager.quickFilter, formatValue(params.value, schemaColumn.type));
        };
    } else if (schemaColumn.type === "media" || schemaColumn.type === "binary") {
        columnDef.cellRenderer = function (params) {
            return highlightFilter(params.column.gridApi.filterManager.quickFilter, formatValue(params.value, schemaColumn.type, params.node.rowHeight - 2));
        };
    } else if (schemaColumn.references) {
        registerNeedToCache(schemaColumn.references.model, schemaColumn.references.column, appName);
        columnDef.getQuickFilterText = function (params) {
            return formatColumnValue(schemaColumn, params.value, appName, params.node.rowHeight - 2);
        };
        columnDef.cellRenderer = function (params) {
            const eDiv = document.createElement('div');

            if(!params.value){
                eDiv.innerHTML = '' ;
                return;
            }

            eDiv.innerHTML = '<i class="fas fa-circle-notch fa-pulse"></i>' ;

            let urlResource = getUrlOfLink2One(schema, schemaColumn) ;
            /*if(urlResource.includes("?")){
                urlResource += "&deepLevel=0";
            }else{
                urlResource += "?deepLevel=0";
            }*/
            getFromCacheOrFetch(urlResource, schemaColumn.references.column, params.value, appName).then((record)=>{
                let rendered = "";
                if(record){
                    rendered = record[schemaColumn.references.label] ;
                    if(schemaColumn.references.label.indexOf("{{") !== -1){
                        Mustache.parse(schemaColumn.references.label);
                        let formattedRecord = JSON.parse(JSON.stringify(record)) ;
                        formatObj(formattedRecord) ;
                        rendered = Mustache.render(schemaColumn.references.label, formattedRecord); 
                    }
                }
                eDiv.innerHTML = highlightFilter(params.column.gridApi.filterManager.quickFilter, rendered);
            }) ;
            return eDiv;
        };
    } else if (schemaColumn.type === "user") {
        registerNeedToCache("users_by_app", "login", "$bamz");
        columnDef.getQuickFilterText = function (params) {
            return formatColumnValue(schemaColumn, params.value, appName, params.node.rowHeight - 2);
        };
        columnDef.cellRenderer = function (params) {
            const eDiv = document.createElement('div');

            if(!params.value){
                eDiv.innerHTML = '' ;
                return;
            }

            eDiv.innerHTML = '<i class="fas fa-circle-notch fa-pulse"></i>' ;

            let urlResource = "users" ;
            getFromCacheOrFetch(urlResource, "login", params.value, "$bamz").then((record)=>{
                let rendered = "";
                if(record){
                    rendered = record["name"] ;
                }
                eDiv.innerHTML = highlightFilter(params.column.gridApi.filterManager.quickFilter, rendered);
            }) ;
            return eDiv;
        };
    } else if ((schemaColumn.type === "array-selection" || schemaColumn.type === "selection" || schemaColumn.type === "radio" ) && schemaColumn.values) {
        columnDef.getQuickFilterText = function (params) {
            if (!params.value) {
                return "";
            }
            let value = params.value;
            if(!Array.isArray(value)){
                value = [value] ;
            }
            value = value.map(value=>{
                if(Array.isArray(schemaColumn.values)){
                    const trKey = "values." + schemaColumn.tableName + "." + schemaColumn.name + "." + value ;
                    const valTranslated = tr(trKey) ;
                    if(valTranslated !== trKey){
                        return valTranslated;
                    }else{
                        return value;
                    }
                }else if(schemaColumn.values){
                    return schemaColumn.values[value]||value ;
                }
            });
            return value.join(", ");
        };
        columnDef.cellRenderer = function (params) {
            return highlightFilter(params.column.gridApi.filterManager.quickFilter, columnDef.getQuickFilterText(params));
        };
    }

    if (!columnDef.cellRenderer && !columnDef.valueFormatter && schemaColumn.type) {
        columnDef.cellRenderer = function (params) {
            return highlightFilter(params.column.gridApi.filterManager.quickFilter, formatValue(params.value, schemaColumn.type,null, schemaColumn.size));
        };
    }

    if (schemaColumn.type) {
        if (!columnDef.getQuickFilterText) {
            columnDef.getQuickFilterText = function (params) {
                return formatValue(params.value, schemaColumn.type, null, schemaColumn.size);
            };
        }
        if (!columnDef.valueFormatter) {
            columnDef.valueFormatter = columnDef.getQuickFilterText;
        }
        if (["int", "integer", "double", "float", "number", "decimal", "numeric"].indexOf(schemaColumn.type) !== -1) {
            columnDef.filter = "agNumberColumnFilter";
            columnDef.filterParams = { clearButton: true };
        } else if (["checkbox"].indexOf(schemaColumn.type) !== -1) {
            columnDef.filterParams = {
                clearButton: true,
                filterOptions: [
                    'empty',
                    {
                        displayKey: 'checked',
                        displayName: tr('grid.checked'),
                        test: function (filterValue, cellValue) {
                          return cellValue != null && ""+cellValue === "true";
                        },
                        hideFilterInput: true,
                    },
                    {
                        displayKey: 'unchecked',
                        displayName: tr('grid.unchecked'),
                        test: function (filterValue, cellValue) {
                          return !cellValue || ""+cellValue === "false";
                        },
                        hideFilterInput: true,
                    },
                ]
            };
        } else if (schemaColumn.references) {
            columnDef.filterParams = {
                clearButton: true,
                filterOptions: [
                    {
                        displayKey: 'containsref',
                        displayName: tr('aggrid.contains'),
                        test: function (filterValue, cellValue) {
                            let formattedValue = formatColumnValue(schemaColumn, cellValue, appName, 10) || "" ;
                            return formattedValue.toLowerCase().includes(filterValue.toLowerCase()) ;
                        },
                    }
                ]
            };

            columnDef.comparator = (valueA, valueB, nodeA, nodeB, isInverted) => {
                if (valueA == valueB) return 0;
                valueA = columnDef.valueFormatter({value: valueA, node: nodeA}) ;
                valueB = columnDef.valueFormatter({value: valueB, node: nodeB}) ;
                return (valueA > valueB) ? 1 : -1;
            } ;

        } else if (schemaColumn.values) {
            let filterOptions = ["empty"] ;
            
            filterOptions.push({
                displayKey: "null",
                displayName: tr("aggrid.noValue"),
                test: function (filterValue, cellValue) {
                    return !cellValue;
                },
                hideFilterInput: true,
            }) ;

            if(Array.isArray(schemaColumn.values)){
                for(let value of schemaColumn.values){
                    const trKey = "values." + schemaColumn.tableName + "." + schemaColumn.name + "." + value ;
                    const valTranslated = tr(trKey) ;
                    filterOptions.push({
                        displayKey: value,
                        displayName: valTranslated !== trKey?valTranslated:value,
                        test: function (filterValue, cellValue) {
                            return (cellValue||"").toLowerCase() === value.toLowerCase();
                        },
                        hideFilterInput: true,
                    }) ;
                }
            }else{
                Object.keys(schemaColumn.values).forEach(value=>{
                    filterOptions.push({
                        displayKey: value,
                        displayName: schemaColumn.values[value],
                        test: function (filterValue, cellValue) {
                            return (cellValue||"").toLowerCase() === value.toLowerCase();
                        },
                        hideFilterInput: true,
                    }) ;
                }) ;
            }
            columnDef.filterParams = {
                filterOptions:filterOptions
            } ;
        } else if (["date", "datetime", "timestamp"].indexOf(schemaColumn.type) !== -1) {
            columnDef.filter = "agDateColumnFilter";
            columnDef.filterParams = {
                inRangeInclusive: true,
                buttons: ['apply', 'clear'],
                comparator: function (filterLocalDateAtMidnight, cellValue) {
                    var cellDate = new Date(cellValue);
                    cellDate.setHours(0);
                    cellDate.setMinutes(0);
                    cellDate.setSeconds(0);
                    cellDate.setMilliseconds(0);
                    if (filterLocalDateAtMidnight.getTime() == cellDate.getTime()) {
                        return 0;
                    }
                    if (cellDate.getTime() < filterLocalDateAtMidnight.getTime()) {
                        return -1;
                    }
                    if (cellDate.getTime() > filterLocalDateAtMidnight.getTime()) {
                        return 1;
                    }
                }
            };
        } else {
            columnDef.filter = "agTextColumnFilter";
            columnDef.filterParams = {
                textFormatter: function (value) {
                    return formatValue(value, schemaColumn.type);
                }
            };

            columnDef.filterParams.clearButton = true;
            columnDef.filterParams.textCustomComparator = function (filter, value, filterText) {
                var filterTextLoweCase = filterText.toLowerCase();
                var valueLowerCase = value.toString().toLowerCase();
                switch (filter) {
                    case 'contains':
                        return valueLowerCase.indexOf(filterTextLoweCase) >= 0;
                    case 'notContains':
                        return valueLowerCase.indexOf(filterTextLoweCase) === -1;
                    case 'equals':
                        return valueLowerCase === filterTextLoweCase;
                    case 'notEqual':
                        return valueLowerCase != filterTextLoweCase;
                    case 'startsWith':
                        return valueLowerCase.indexOf(filterTextLoweCase) === 0;
                    case 'endsWith':
                        var index = valueLowerCase.lastIndexOf(filterTextLoweCase);
                        return index >= 0 && index === (valueLowerCase.length - filterTextLoweCase.length);
                    default:
                        console.warn('invalid filter type ' + filter);
                        return false;
                }
            };
        }
    }
    return columnDef ;
}

function formatObj(obj){
    Object.keys(obj).forEach(k=>{
        const val = obj[k] ;
        if(val && ({}).constructor === val.constructor){
            formatObj(val) ;
        }else{
            obj[k] = formatValue(obj[k]) ;
        }
    });
}

window.Z_GRID.createColDef = createColDef;
window.Z_GRID.createColDefFromSchema = createColDefFromSchema;

//documentation ag grid : https://www.ag-grid.com/javascript-grid-cell-editor/
export function getZGridDefaultEditor() {
    // function to act as a class
    function GridDefaultEditor() { }

    GridDefaultEditor.prototype.createField = function (params) {
        const zFieldOnly = document.createElement('z-field-only');

        Object.keys(params.colDef).forEach(key => {
            if(/^zfield/.test(key)){
                zFieldOnly.setAttribute(key.replace(/^zfield/, "").split(/(?=[A-Z][^A-Z])/).join("-").toLocaleLowerCase(), params.colDef[key]) ;
            }
        }) ;
    
        if(params.zApp){
            zFieldOnly.setAttribute("z-app", params.zApp);
        }
        zFieldOnly.setAttribute("z-model", params.zModel);


        zFieldOnly.addEventListener("keyup", ()=>{
            if(!zFieldOnly.checkValidity()){
                zFieldOnly.classList.add("text-danger") ;
            }else{
                zFieldOnly.classList.remove("text-danger") ;
            }
        }) ;

        return zFieldOnly ;
    };

    // gets called once before the renderer is used
    GridDefaultEditor.prototype.init = function (params) {
        // create the cell

        this.params = params;

        if(params.zIsDialog){
            this.zFieldOnly = document.createElement('BUTTON');
            this.zFieldOnly.type = "button";
            this.zFieldOnly.className = "btn btn-outline-primary";
            this.zFieldOnly.innerHTML = tr("form.modify") ;
            this.zFieldOnly.checkValidity = function(){ return true ; } ;

            this.zFieldOnly.addEventListener("click", ()=>{
                openDialog((el, $modal)=>{
                    const div = document.createElement("DIV") ;

                    const zField = this.createField(params) ;

                    div.appendChild(zField) ;

                    const divButtons = document.createElement("DIV") ;
                    divButtons.className = "d-flex mt-2" ;
                    const buttonValidate = document.createElement("BUTTON") ;
                    buttonValidate.type = "button" ;
                    buttonValidate.className = "btn btn-success ml-auto";
                    buttonValidate.innerHTML = tr("form.validate") ;
                    const buttonCancel = document.createElement("BUTTON") ;
                    buttonCancel.type = "button" ;
                    buttonCancel.className = "btn btn-outline-secondary";
                    buttonCancel.innerHTML = tr("form.cancel") ;

                    buttonValidate.addEventListener("click", ()=>{
                        this.zFieldOnly.value = zField.value ;
                        params.data[params.colDef.field] = zField.value ;
                        
                        let zGrid = params.eGridCell.closest("z-grid") ;
                        if(zGrid.autoSave){
                            let fieldId = "_id" ;
                            if(zGrid.hasAttribute("z-field-id")){
                                fieldId = zGrid.getAttribute("z-field-id") ;
                            }
                            const dataPatch = getSavePatch(zGrid, fieldId, zGrid.data.indexOf(params.data)) ;
                            if(dataPatch.dataPatch){
                                //this edition has modif to save
                                waiter(save(dataPatch, fieldId)).then(()=>{
                                    params.stopEditing() ;
                                    params.api.refreshCells({rowNodes: [params.node], force: true, columns: [params.colDef.field] }) ;
                                }) ;
                            }
                        }else{
                            params.stopEditing() ;
                        }
                        $modal.modal('hide') ;
                    });
                    let originalValue = null ;
                    if(params.data[params.colDef.field]){
                        originalValue = JSON.parse(JSON.stringify(params.data[params.colDef.field])) ;
                    }
                    buttonCancel.addEventListener("click", ()=>{
                        params.data[params.colDef.field] = originalValue ;
                        $modal.modal('hide') ;
                    });

                    divButtons.appendChild(buttonCancel);
                    divButtons.appendChild(buttonValidate);

                    div.appendChild(divButtons) ;
                    
                    el.appendChild(div) ;
                    
                    let promiseValue = Promise.resolve(params.data[params.colDef.field]) ;
                    if(params.zType === "one2many"){
                        const filter = [
                            { column : params.zSchemaColumn.one2many.column, value: params.data._id}
                        ] ;
                        promiseValue = window.getRestApi(params.colDef.cellEditorParams.zApp).list(params.zSchemaColumn.one2many.model, filter);
                    }

                    promiseValue.then((result)=>{
                        let fieldValue = result ;
                        if(params.zType === "one2many"){
                            params.data[params.colDef.field] = result||[] ;  
                            fieldValue = params.data[params.colDef.field] ;
                        }
                        if(zField.notifyChange){
                            if(zField.value && zField.value.addListener){
                                zField.value.addListener("*", ()=>{
                                    zField.notifyChange() ;
                                }) ;
                            }else if(zField.value){
                                zField.notifyChange() ;
                            }else if(fieldValue){
                                fieldValue.addListener("*", ()=>{
                                    zField.notifyChange() ;
                                }) ;
                            }
                        }
                        zField.value = fieldValue ;
                        if(params.zType === "one2many") {
                            zField.querySelectorAll("button[type='button'].dropdown-toggle").forEach(btn => {
                                btn.addEventListener("click", ()=>{
                                    if(btn.parentElement.className.includes("show")) {
                                        btn.parentElement.classList.remove("show");
                                        btn.nextElementSibling.classList.remove("show");
                                    } else {
                                        btn.parentElement.classList.add("show");
                                        btn.nextElementSibling.classList.add("show");
                                    }
                                });
                            });
                        }
                    }) ;


                }, {size: "medium"}) ;
            }) ;
        }else{
            this.zFieldOnly = this.createField(params) ;
    
            this.zFieldOnly.addEventListener("modal-editor-closed", ()=>{
                params.stopEditing() ;
            }) ;
        }

    };


    GridDefaultEditor.prototype.isCancelAfterEnd = function(){
        return !this.zFieldOnly.checkValidity() ;
    } ;
    
    // gets called once when grid ready to insert the element
    GridDefaultEditor.prototype.getGui = function () {
        return this.zFieldOnly;
    };
    
    // focus and select can be done after the gui is attached
    GridDefaultEditor.prototype.afterGuiAttached = function () {
        //set value after gui attached to be sure the widget init is done

        this.zFieldOnly.value = this.params.value ;

        this.zFieldOnly.removeAttribute("z-bind") ;
        if(this.zFieldOnly.hasAttribute("z-bind-url")){
            this.zFieldOnly.setAttribute("z-bind-url", 
            this.zFieldOnly.getAttribute("z-bind-url").replace("${_id}", this.params.data._id)) ;
        }else{
            const parentBind = this.zFieldOnly.parentElement.closest("[z-bind]") ;
            if(parentBind){
                const bindSettings = JSON.parse(parentBind.getAttribute("z-bind")) ;
                const fieldBind = { _value: bindSettings._value+"."+this.params.rowIndex+"."+this.params.colDef.field } ;
                this.zFieldOnly.setAttribute("z-bind", JSON.stringify(fieldBind)) ;
            }
        }

        if(this.zFieldOnly.select){
            this.zFieldOnly.focus();
            this.zFieldOnly.select();
        }
        
        if(this.zFieldOnly.field && this.zFieldOnly.field.type === 'checkbox'){
            this.zFieldOnly.style = 'display: flex; justify-content: center; align-items: center; height: 100% ';
        } else if(this.zFieldOnly.field && this.zFieldOnly.field.type === 'textarea'){
            let gridHeight = this.zFieldOnly.closest("z-grid").offsetHeight;
            let marginTop = parseInt(this.zFieldOnly.parentElement.style.top.replace("px", ""));
            let maxHeight = marginTop + gridHeight * 0.5;
            if (maxHeight > gridHeight) {
                this.zFieldOnly.parentElement.style.top = (parseInt(marginTop) - gridHeight * 0.5 + this.params.node.rowHeight -2) + "px";
            }
            let gridWidth = this.zFieldOnly.closest("z-grid").offsetWidth;
            let marginLeft = parseInt(this.zFieldOnly.parentElement.style.left.replace("px", ""));
            if(document.documentElement.clientWidth * 0.5 + marginLeft > gridWidth){
                this.zFieldOnly.parentElement.style.left =  (this.params.column.actualWidth + marginLeft - gridWidth * 0.5) + "px";
            }
            this.zFieldOnly.firstChild.classList.add('form-control');
            this.zFieldOnly.parentElement.style["min-width"] = "0px";
            this.zFieldOnly.querySelector("textarea").style = `min-width:0px;resize:both;width:${gridWidth*0.5}px;height:${gridHeight*0.5}px;`;
        } else if(this.zFieldOnly.field && this.zFieldOnly.field.type === 'radio') {
            this.zFieldOnly.querySelectorAll(".form-check-inline").forEach((el)=>{
                el.className = "form-check";
            });
            this.zFieldOnly.parentElement.style["min-width"] = null;
            this.zFieldOnly.querySelector(".z-radio-container").classList.add("p-2");

            let gridHeight = this.zFieldOnly.closest("z-grid").offsetHeight;
            let marginTop = parseInt(this.zFieldOnly.parentElement.style.top.replace("px", ""));
            let maxHeight = marginTop + this.zFieldOnly.querySelector(".z-radio-container").offsetHeight;
            if (maxHeight > gridHeight) {
                this.zFieldOnly.parentElement.style.top = null;
                this.zFieldOnly.parentElement.style.bottom = (gridHeight - marginTop - this.params.node.rowHeight) + "px";
            }
        } else if(this.zFieldOnly.field && this.zFieldOnly.field.type === 'icon') {
            let gridHeight = this.zFieldOnly.closest("z-grid").offsetHeight;
            let marginTop = parseInt(this.zFieldOnly.parentElement.style.top.replace("px", ""));
            let maxHeight = marginTop + 17*16;
            if (maxHeight > gridHeight) {
                this.zFieldOnly.querySelector(".icon-picker").classList.remove("dropdown");
                this.zFieldOnly.querySelector(".icon-picker").classList.add("dropup");
            }
            this.zFieldOnly.querySelector("button").click();
        } else if(this.zFieldOnly.field && this.zFieldOnly.field.type === "sequence") {
            let input = document.createElement("input");
            input.style = "width:0;height:0;border:0px;border-radius:0px;opacity:0;display: inline";
            this.zFieldOnly.querySelector("z-format").appendChild(input);
            input.focus();
        }

    };

    // returns the new value after editing
    GridDefaultEditor.prototype.getValue = function () {
        if(this.params.zIsDialog){
            return this.params.data[this.params.colDef.field] ;
        }
        return this.zFieldOnly.value;
    };

    // any cleanup we need to be done here
    GridDefaultEditor.prototype.destroy = function () {
        // but this example is simple, no cleanup, we could
        // even leave this method out as it's optional
        if(this.zFieldOnly.field && (this.zFieldOnly.field.type === 'datetime' || this.zFieldOnly.field.type === 'time' || this.zFieldOnly.field.type === 'timestamp')){
            setTimeout(()=>{
                this.params.api.refreshCells({rowNodes: [this.params.node], force: true, columns: [this.params.colDef.field] }) ;
            }, 200);
        }
    };

    // if true, then this editor will appear in a popup
    GridDefaultEditor.prototype.isPopup = function () {
        return this.params.zIsPopup;
    };

    return GridDefaultEditor;
}

export function getZGridRichTextEditor() {
    function GridRichTextEditor() { }

    GridRichTextEditor.prototype.init = function (params) {
        this.params = params;

        this.zFieldOnly = document.createElement('z-field-only');
        if (params.zApp) {
            this.zFieldOnly.setAttribute("z-app", params.zApp);
        }
        this.zFieldOnly.setAttribute("z-model", params.zModel);
        const parentBindEl = params.eGridCell.closest("[z-bind]") ;
        let bindSettings = {} ;
        if(parentBindEl){
            try{
                const parentBind = JSON.parse(parentBindEl.getAttribute("z-bind")) ;
                bindSettings._value = parentBind._value+"."+params.rowIndex+"."+params.colDef.field ;
            }catch(e){
                console.log("Bad format bind ", parentBindEl.getAttribute("z-bind")) ;
            }
        }
        this.zFieldOnly.setAttribute("z-bind", JSON.stringify(bindSettings));
        this.zFieldOnly.setAttribute('value', this.params.value || "");

        this.eGui = document.createElement("div");
        this.eGui.classList.add("p-2");
        this.eGui.appendChild(this.zFieldOnly);
        this.eGui.style = "resize:both;overflow:auto;width:0;position:relative";
        this.eGui.style.height = "0px";

        this.dummyElement = document.createElement("textarea");
        this.dummyElement.style = "width:0;height:0;position:absolute;top:-10px;left:-10px";
        this.eGui.appendChild(this.dummyElement);
    } ;

    GridRichTextEditor.prototype.afterGuiAttached = function () {
        let gridHeight = this.eGui.closest("z-grid").offsetHeight;
        let marginTop = parseInt(this.eGui.parentElement.style.top.replace("px", ""));
        let maxHeight = marginTop + gridHeight * 0.5;
        if (maxHeight > gridHeight) {
            this.eGui.parentElement.style.top = (parseInt(marginTop) - gridHeight * 0.5 + this.params.node.rowHeight - 2) + "px";
        }
        let gridWidth = this.zFieldOnly.closest("z-grid").offsetWidth;
        let marginLeft = parseInt(this.eGui.parentElement.style.left.replace("px", ""));
        if (document.documentElement.clientWidth * 0.5 + marginLeft > gridWidth) {
            this.eGui.parentElement.style.left = (this.params.column.actualWidth + marginLeft - gridWidth * 0.5) + "px";
        }
        this.eGui.parentElement.style["min-width"] = "0px";
        this.eGui.style = `resize:both;overflow:auto;width:${gridWidth * 0.5}px;height:${gridHeight * 0.5}px;position:relative`;
        this.dummyElement.focus();
    } ;

    GridRichTextEditor.prototype.getValue = function () {
        return this.zFieldOnly.value;
    } ;

    GridRichTextEditor.prototype.isPopup = function () {
        return true;
    };

    GridRichTextEditor.prototype.getGui = function () {
        return this.eGui;
    };

    return GridRichTextEditor;
}

export function getZGridMediaEditor() {
    function GridMediaEditor(){ }

    GridMediaEditor.prototype.createField = function (params) {
        const zFieldOnly = document.createElement('z-field-only');

        if (params.zApp) {
            zFieldOnly.setAttribute("z-app", params.zApp);
        }
        zFieldOnly.setAttribute("z-model", params.zModel);

        zFieldOnly.addEventListener("keyup", () => {
            if (!zFieldOnly.checkValidity()) {
                zFieldOnly.classList.add("text-danger");
            } else {
                zFieldOnly.classList.remove("text-danger");
            }
        });

        return zFieldOnly;
    };

    GridMediaEditor.prototype.init = function(params){
        const divButtons = document.createElement("DIV");
        divButtons.className = "d-flex mt-2";

        const buttonCancel = document.createElement("BUTTON");
        buttonCancel.type = "button";
        buttonCancel.className = "btn btn-sm btn-outline-secondary";
        buttonCancel.innerHTML = tr("form.cancel");
        buttonCancel.addEventListener("click", ()=>{
            this.isCancelEdit = true;
            params.stopEditing() ;
        });

        const buttonValidate = document.createElement("BUTTON");
        buttonValidate.type = "button";
        buttonValidate.className = "btn btn-sm btn-success ml-auto";
        buttonValidate.innerHTML = tr("form.validate");
        buttonValidate.addEventListener("click", ()=>{
            this.isCancelEdit = false;
            params.stopEditing() ;
        });

        divButtons.appendChild(buttonCancel);
        divButtons.appendChild(buttonValidate);

        const zFieldOnly = document.createElement('z-field-only');
        if (params.zApp) {
            zFieldOnly.setAttribute("z-app", params.zApp);
        }
        zFieldOnly.setAttribute("z-model", params.zModel);

        const div = document.createElement("FORM");
        div.className = "p-2";
        div.style.height = "0px";
        div.appendChild(zFieldOnly);
        div.appendChild(divButtons);

        this.isCancelEdit = true;
        this.params = params;
        this.zFieldOnly = zFieldOnly;
        this.eGui = div;
    };

    GridMediaEditor.prototype.isCancelAfterEnd = function() {
        return this.isCancelEdit;
    };

    GridMediaEditor.prototype.getGui = function(){
        return this.eGui;
    };

    GridMediaEditor.prototype.getValue = function () {
        return this.zFieldOnly.value;
    };

    GridMediaEditor.prototype.afterGuiAttached = function () {
        this.zFieldOnly.querySelector('img').style = "max-width: 100%; max-height: 5rem";
        this.zFieldOnly.querySelector('audio').style = "max-width: 100%; max-height: 5rem";
        this.zFieldOnly.querySelector('video').style = "max-width: 100%; max-height: 5rem";
        this.zFieldOnly.querySelector('input[type=text]').classList.add("form-control-sm");
        this.zFieldOnly.value = this.params.value ;
        
        let gridHeight = this.eGui.closest("z-grid").offsetHeight;
        let marginTop = parseInt(this.eGui.parentElement.style.top.replace("px", ""));
        let maxHeight = marginTop + 179;
        if (maxHeight > gridHeight) {
            this.eGui.parentElement.style.top = null;
            this.eGui.parentElement.style.bottom = (gridHeight - marginTop - this.params.node.rowHeight - 2) + "px";
        }
        this.eGui.style = "";
    };

    GridMediaEditor.prototype.isPopup = function () {
        return true;
    };

    return GridMediaEditor;
}

export function getZGridBinaryEditor(){
    function GridBinaryEditor(){ }
    GridBinaryEditor.prototype.init = function(params){
        const zFieldOnly = document.createElement('z-field-only');
        if (params.zApp) {
            zFieldOnly.setAttribute("z-app", params.zApp);
        }
        zFieldOnly.setAttribute("z-model", params.zModel);

        const divButtons = document.createElement("DIV");
        divButtons.className = "d-flex mt-2";

        const buttonCancel = document.createElement("BUTTON");
        buttonCancel.type = "button";
        buttonCancel.className = "btn btn-sm btn-outline-secondary";
        buttonCancel.innerHTML = tr("form.cancel");
        buttonCancel.addEventListener("click", ()=>{
            this.isCancelEdit = true;
            params.stopEditing() ;
        });

        const buttonValidate = document.createElement("BUTTON");
        buttonValidate.type = "button";
        buttonValidate.className = "btn btn-sm btn-success ml-auto";
        buttonValidate.innerHTML = tr("form.validate");
        buttonValidate.addEventListener("click", ()=>{
            this.isCancelEdit = false;
            params.stopEditing();
        });

        divButtons.appendChild(buttonCancel);
        divButtons.appendChild(buttonValidate);

        const div = document.createElement("DIV");
        div.className = "p-2";
        div.style.height = "0px";
        div.appendChild(zFieldOnly);
        div.appendChild(divButtons);

        this.isCancelEdit = true;
        this.params = params;
        this.zFieldOnly = zFieldOnly;
        this.eGui = div;
    };

    GridBinaryEditor.prototype.getGui = function(){
        return this.eGui;
    };

    GridBinaryEditor.prototype.getValue = function(){
        return this.zFieldOnly.value;
    };

    GridBinaryEditor.prototype.afterGuiAttached = function(){
        this.zFieldOnly.querySelector('input[type=text]').classList.add("form-control-sm");
        this.zFieldOnly.value = this.params.value;

        let gridHeight = this.eGui.closest("z-grid").offsetHeight;
        let marginTop = parseInt(this.eGui.parentElement.style.top.replace("px", ""));
        let maxHeight = marginTop + 132;
        if (maxHeight > gridHeight) {
            this.eGui.parentElement.style.top = null;
            this.eGui.parentElement.style.bottom = (gridHeight - marginTop - this.params.node.rowHeight - 2) + "px";
        }
        this.eGui.style = "";
    };

    GridBinaryEditor.prototype.isPopup = function(){
        return true;
    };

    GridBinaryEditor.prototype.isCancelAfterEnd = function() {
        return this.isCancelEdit;
    };

    return GridBinaryEditor;
}

export function getZGridCodeHtmlEditor() {
    function GridCodeHtmlEditor() { }

    GridCodeHtmlEditor.prototype.init = function (params) {
        this.params = params;

        this.zFieldOnly = document.createElement('z-field-only');
        if (params.zApp) {
            this.zFieldOnly.setAttribute("z-app", params.zApp);
        }
        this.zFieldOnly.setAttribute("z-model", params.zModel);
        this.zFieldOnly.setAttribute('value', this.params.value || "");

        this.eGui = document.createElement("div");
        this.eGui.style = "resize:both;overflow:auto;width:0px;position:relative";
        this.eGui.style.height = "0px";
        this.eGui.classList.add("p-2");
        this.eGui.appendChild(this.zFieldOnly);

        this.dummyElement = document.createElement("textarea");
        this.dummyElement.style = "width:0;height:0;position:absolute;top:-10px;left:-10px";
        this.eGui.appendChild(this.dummyElement);
    };

    GridCodeHtmlEditor.prototype.afterGuiAttached = function () {
        let gridHeight = this.eGui.closest("z-grid").offsetHeight;
        let marginTop = parseInt(this.eGui.parentElement.style.top.replace("px", ""));
        let maxHeight = marginTop + gridHeight * 0.5;
        if (maxHeight > gridHeight) {
            this.eGui.parentElement.style.top = (parseInt(marginTop) - gridHeight * 0.5 + this.params.node.rowHeight -2) + "px";
        }
        let gridWidth = this.zFieldOnly.closest("z-grid").offsetWidth;
        let marginLeft = parseInt(this.eGui.parentElement.style.left.replace("px", ""));
        if (document.documentElement.clientWidth * 0.5 + marginLeft > gridWidth) {
            this.eGui.parentElement.style.left = (this.params.column.actualWidth + marginLeft - gridWidth * 0.5) + "px";
        }
        this.eGui.parentElement.style["min-width"] = "0px";
        this.eGui.style = `resize:both;overflow:auto;width:${gridWidth*0.5}px;height:${gridHeight*0.5}px;position:relative`;
        this.dummyElement.focus();
    };

    GridCodeHtmlEditor.prototype.getValue = function () {
        return this.zFieldOnly.value;
    };

    GridCodeHtmlEditor.prototype.isPopup = function () {
        return true;
    };

    GridCodeHtmlEditor.prototype.getGui = function () {
        return this.eGui;
    };

    return GridCodeHtmlEditor;
}

export function getZGridComposeHtmlEditor() {
    function GridComposeHtmlEditor() { }

    GridComposeHtmlEditor.prototype.init = function (params) {
        this.params = params;

        this.zFieldOnly = document.createElement('z-field-only');
        if (params.zApp) {
            this.zFieldOnly.setAttribute("z-app", params.zApp);
        }
        this.zFieldOnly.setAttribute("z-model", params.zModel);
        this.zFieldOnly.setAttribute('value', this.params.value || "");

        this.eGui = document.createElement("div");
        this.eGui.style = "resize:both;overflow:auto;width:0px;height:0px;position:relative";
        this.eGui.classList.add("p-2");
        this.eGui.appendChild(this.zFieldOnly);

        this.dummyElement = document.createElement("textarea");
        this.dummyElement.style = "width:0;height:0;position:absolute;top:-10px;left:-10px";
        this.eGui.appendChild(this.dummyElement);
    };

    GridComposeHtmlEditor.prototype.afterGuiAttached = function () {
        let gridHeight = this.eGui.closest("z-grid").offsetHeight;
        let marginTop = parseInt(this.eGui.parentElement.style.top.replace("px", ""));
        let maxHeight = marginTop + gridHeight * 0.5;
        if (maxHeight > gridHeight) {
            this.eGui.parentElement.style.top = (parseInt(marginTop) - gridHeight * 0.5 + this.params.node.rowHeight -4) + "px";
        }
        let gridWidth = this.zFieldOnly.closest("z-grid").offsetWidth;
        let marginLeft = parseInt(this.eGui.parentElement.style.left.replace("px", ""));
        if (document.documentElement.clientWidth * 0.5 + marginLeft > gridWidth) {
            this.eGui.parentElement.style.left = (this.params.column.actualWidth + marginLeft - gridWidth * 0.5) + "px";
        }

        this.zFieldOnly.querySelectorAll("iframe")[1].style.height = "100%";

        this.eGui.parentElement.style["min-width"] = "0px";
        this.eGui.style = `resize:both;overflow:auto;width:${gridWidth*0.5}px;height:${gridHeight*0.5}px;position:relative`;
        this.dummyElement.focus();
    };

    GridComposeHtmlEditor.prototype.getValue = function () {
        return this.zFieldOnly.value;
    };

    GridComposeHtmlEditor.prototype.isPopup = function () {
        return true;
    };

    GridComposeHtmlEditor.prototype.getGui = function () {
        return this.eGui;
    };

    return GridComposeHtmlEditor;
}

export function getZGridTooltip() {
    function GridTooltip() { }

    GridTooltip.prototype.init = function (params) {
        let eGui = (this.eGui = document.createElement('div'));
        eGui.classList.add('z-grid-tooltip');
        let media = params.value || {};
        if (/^image/.test(media.mimetype)) {
            eGui.innerHTML = `<img src="${media.url}" style="max-width: 100%; max-height: 100%">`;
        } else if (/^video/.test(media.mimetype)) {
            eGui.innerHTML = `<video controls autoplay preload="auto" style="max-width: 100%; max-height: 100%; display: block">
                // <source  src="${media.url}" type="${media.mimetype}">
                <source  src="${media.url}" type="${media.mimetype}">
                Your browser does not support the video tag.
            </video>` ;
        }
    };

    GridTooltip.prototype.getGui = function () {
        return this.eGui;
    };

    return GridTooltip;
}